// import React, { useState, useEffect, useRef } from 'react';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import {
//   Card,
//   Row,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   FormText,
//   Table,
//   Alert,
//   CardFooter,
// } from 'reactstrap';
// import ReactPaginate from 'react-paginate';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { useSelector } from 'react-redux';
// // import IDCardPDF from './IDCardPDF';
// import { BlobProvider } from '@react-pdf/renderer';
// import { formatDate } from '../../constants/DateFormatter';

// const ICardBatches = () => {
//   const navigate = useNavigate();
//   const [ICardList, setICardList] = useState([]);
//   const [classMasterData, setClassMasterData] = useState([]);
//   const sessionData = useSelector((state)=> state.sessionState)

//   const [search, setSearch] = useState("");
//   const [curr_sec, setcurr_sec] = useState("");
//   const [curr_class, setcurr_class] = useState("");
//   const onHandleAddAdmission = () => {
//     navigate('/saveICardBatches');
//   };



//   const onHandleEdit = (id) => {
//     let findArrayData = ICardList.find((e) => e.id === id);
//     navigate('/SaveICardBatches', { state: { ...findArrayData } });
//   };

//   const onHandleDeleteAdmission = async (id) => {
//     const isDeleteConfirmed = window.confirm(
//       'Are you sure you want to delete this item?'
//     );
//     if (isDeleteConfirmed) {
//       try {
//         let config = {
//           headers: {
//             'Content-Type': 'application/json', // Important for file upload//s
//             accept: 'application/json',
//           },
//         };

//         const response = await apiService.delete(
//           `api/Admission/DeleteAdmission?id=${id}`,
//           config
//         );
//         if (response.response && response.response.data.errors) {
//           alert(response.response?.data?.errors);
//         }

//         if (response.status === true) {
//           alert(response.message);
//           //GetAllBatches();
//         } else {
//           alert(response.message);
//         }
//       } catch (error) {
//         console.log(error);
//         alert('SomeThing went wrong!!');
//       }
//     } else {
//       console.log('Deletion canceled.');
//     }
//   };


//   const fetchData = async () => {
//     try {
//       const queryParams = new URLSearchParams();

//       queryParams.append("session", sessionData.session_year)
//       // if (search) queryParams.append("search", search);
//       // if (curr_class) queryParams.append("curr_class", curr_class);
//       // if (curr_sec) queryParams.append("curr_sec", curr_sec);


//       const response = await apiService.get(`api/I_Card/GetAllBatches?${queryParams.toString()}`);
//       if (response.status === true) {
//         setICardList(response.iCardList)
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     GetCurrectClassInfo();
//   }, [search, curr_class, curr_sec]);


//   // useEffect(() => {
//   //   GetAllBatches();
//   // }, [!ICardList]);

// const tableRef = useRef();

//   const GetCurrectClassInfo = async () => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       const response = await apiService.get(
//         `api/Admission/GetClass_MasterGroupData`,
//         config
//       );

//       setClassMasterData(response.item2);
//     } catch (error) {
//       console.log(error);
//       alert('SomeThing went wrong');
//     }
//   };


//   return (
//     <>

//       <div className='text-right mb-2'>
//           {/*  <Button onClick={handleStudentListPrint} className="btn btn-danger">
//                <i className='bi bi-printer mr-2'/> Print Student List
//               </Button>&nbsp;
//      <Button
//           color='success' onClick={() => exportToExcel(ICardList, "StudentList.xlsx")}>
//         Export to Excel
//       </Button>   &nbsp; 
//               <BlobProvider
//                   document={<IDCardPDF students={ICardList}/>}
//                 >
//                   {({ url }) => {
//                     return (
//                       <button
//                         className="btn btn-warning"
//                         onClick={() => {
//                           if (url) {
//                             // Open the PDF in a new tab
//                             window.open(url, '_blank');
//                           }
//                         }}
//                       >
//                         <i className="bi bi-printer" /> Print I-Cards
//                       </button>
//                     );
//                   }}
//                 </BlobProvider>*/}
//                 &nbsp;
//         <Button
//           color='primary'
//           onClick={onHandleAddAdmission}
//         >
//           Add new
//         </Button>
//       </div>
//       <Col lg='12'>
//         <Card className='card-box height-100-p pd-20 mb-20'>
//           <CardTitle
//             tag='h6'
//             className='p-3 mb-0 d-flex align-items-center justify-content-between'
//           >
//             <div className='d-flex align-items-center'>
//               <i className='bi bi-card-text mr-2'></i>
//               I CARD BATCHES 
//             </div>



//           </CardTitle>

        

//           <CardBody>
//             <div ref={tableRef} className='table-responsive'>
//               <Table hover striped responsive>
//                 <thead>
//                   <tr>
//                     <th>S.no.</th>
//                     <th className='no-print'></th>
//                     <th>Adm. No.-1</th>
//                     <th>Adm. No.-2</th>
//                     <th>Adm. No.-3</th>
//                     <th>Adm. No.-4</th>
//                     <th>Adm. No.-5</th>
//                     <th>Adm. No.-6</th>
//                     <th>Adm. No.-7</th>
//                     <th>Adm. No.-8</th>
//                     <th>Adm. No.-9</th>
//                     <th>Adm. No.-10</th>

//                     {/* <th>Delete</th> */}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {ICardList.length ? (
//                     ICardList.map((item, index) => (
//                       <tr key={index}>
//                         <th scope='row'>{index + 1}</th>
//                         <td className='no-print'>
//                           <i
//                             style={{ cursor: "pointer" }}
//                             onClick={() => onHandleEdit(item.id)}
//                             className='bi bi-pencil text-primary'></i>
//                         </td>
//                         <td>{item.admit_no_1}</td>
//                         <td>{item.admit_no_2}</td>
//                         <td>{item.admit_no_3}</td>
//                         <td>{item.admit_no_4}</td>
//                         <td>{item.admit_no_5}</td>
//                         <td>{item.admit_no_6}</td>
//                         <td>{item.admit_no_7}</td>
//                         <td>{item.admit_no_8}</td>
//                         <td>{item.admit_no_9}</td>
//                         <td>{item.admit_no_10}</td>

//                         {/* <td>
//                       <Button
//                         color='danger'
//                         size='bg'
//                         onClick={() => onHandleDeleteAdmission(item.id)}
//                       >
//                         Delete
//                       </Button>
//                     </td> */}
//                       </tr>
//                     ))
//                   ) : (
//                     <>
//                       <tr>
//                         <td className='text-center' colSpan={12}>No data available</td>
//                       </tr>
//                     </>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           </CardBody>
//           <CardFooter className='text-right'>
//             (Showing latest 10 entries by default)
//           </CardFooter>
//         </Card>
//       </Col>
//     </>
//   );
// };

// export default ICardBatches;
import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Alert,
  CardFooter,
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { useSelector } from 'react-redux';
import { BlobProvider } from '@react-pdf/renderer';
import { formatDate } from '../../constants/DateFormatter';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';

const ICardBatches = () => {
  const navigate = useNavigate();
  const [ICardList, setICardList] = useState([]);
  const [classMasterData, setClassMasterData] = useState([]);
  const sessionData = useSelector((state)=> state.sessionState);
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [search, setSearch] = useState("");
  const [curr_sec, setcurr_sec] = useState("");
  const [curr_class, setcurr_class] = useState("");

  const onHandleAddAdmission = () => {
    navigate('/saveICardBatches');
  };

  const onHandleEdit = (id) => {
    let findArrayData = ICardList.find((e) => e.id === id);
    navigate('/SaveICardBatches', { state: { ...findArrayData } });
  };

  const onHandleDeleteAdmission = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?'
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/Admission/DeleteAdmission?id=${id}`,
          config
        );
        if (response.response && response.response.data.errors) {
          alert(response.response?.data?.errors);
        }

        if (response.status === true) {
          alert(response.message);
        } else {
          alert(response.message);
        }
      } catch (error) {
        console.log(error);
        alert('SomeThing went wrong!!');
      }
    } else {
      console.log('Deletion canceled.');
    }
  };

  const fetchData = async () => {
    try {
      const queryParams = new URLSearchParams();

      queryParams.append("session", sessionData.session_year);

      if (selectionData.vendor_id) queryParams.append("vendorId", selectionData.vendor_id);
      if (selectionData.branch_id) queryParams.append("branchId", selectionData.branch_id);

      const response = await apiService.get(`api/I_Card/GetAllBatches?${queryParams.toString()}`);
      if (response.status === true) {
        setICardList(response.iCardList);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      fetchData();
      GetCurrectClassInfo();
    } else {
      setICardList([]);
      setClassMasterData([]);
    }
  }, [
    search,
    curr_class,
    curr_sec,
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin
  ]);

  const tableRef = useRef();

  const GetCurrectClassInfo = async () => {
    try {
      const vendorId = selectionData.vendor_id || "";
      const branchId = selectionData.branch_id || "";

      const response = await apiService.get(
        `api/Admission/GetClass_MasterGroupData?vendorId=${vendorId}&branchId=${branchId}&`
      );

      setClassMasterData(response.item2);
    } catch (error) {
      console.log(error);
      alert('SomeThing went wrong');
    }
  };

  return (
    <>
      <div className='text-right mb-2'>
        &nbsp;
        <Button
          color='primary'
          onClick={onHandleAddAdmission}
        >
          Add new
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Col lg='12'>
        <Card className='card-box height-100-p pd-20 mb-20'>
          <CardTitle
            tag='h6'
            className='p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            <div className='d-flex align-items-center'>
              <i className='bi bi-card-text mr-2'></i>
              I CARD BATCHES
            </div>
          </CardTitle>

          <CardBody>
            <div ref={tableRef} className='table-responsive'>
              <Table hover striped responsive>
                <thead>
                  <tr>
                    <th>S.no.</th>
                    <th className='no-print'></th>
                    <th>Adm. No.-1</th>
                    <th>Adm. No.-2</th>
                    <th>Adm. No.-3</th>
                    <th>Adm. No.-4</th>
                    <th>Adm. No.-5</th>
                    <th>Adm. No.-6</th>
                    <th>Adm. No.-7</th>
                    <th>Adm. No.-8</th>
                    <th>Adm. No.-9</th>
                    <th>Adm. No.-10</th>
                  </tr>
                </thead>
                <tbody>
                  {ICardList.length ? (
                    ICardList.map((item, index) => (
                      <tr key={index}>
                        <th scope='row'>{index + 1}</th>
                        <td className='no-print'>
                          <i
                            style={{ cursor: "pointer" }}
                            onClick={() => onHandleEdit(item.id)}
                            className='bi bi-pencil text-primary'></i>
                        </td>
                        <td>{item.admit_no_1}</td>
                        <td>{item.admit_no_2}</td>
                        <td>{item.admit_no_3}</td>
                        <td>{item.admit_no_4}</td>
                        <td>{item.admit_no_5}</td>
                        <td>{item.admit_no_6}</td>
                        <td>{item.admit_no_7}</td>
                        <td>{item.admit_no_8}</td>
                        <td>{item.admit_no_9}</td>
                        <td>{item.admit_no_10}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className='text-center' colSpan={12}>No data available</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ICardBatches;